module.exports = "<div class=\"loader\">\r\n  <svg class=\"circular\" viewBox=\"25 25 50 50\">\r\n    <circle class=\"path\" cx=\"50\" cy=\"50\" r=\"20\" fill=\"none\" stroke-width=\"2\" stroke-miterlimit=\"10\" />\r\n  </svg>\r\n</div>\r\n<p>{{'Loading' | translate}}...</p>"


//////////////////
// WEBPACK FOOTER
// ./src/app/shared/spinner/spinner.component.html
// module id = ./src/app/shared/spinner/spinner.component.html
// module chunks = main